import { ThemeColors } from '../../../'

export interface FloatinMenuColors {
  Background: ThemeColors
  Option: {
    Background: {
      Default: ThemeColors
      Active: ThemeColors
      Hover: ThemeColors
    }
    FontColor: ThemeColors
    IconColor: ThemeColors
  }
}

export const floatingMenuColors: FloatinMenuColors = {
  Background: {
    default: 'bg.panel',
  },
  Option: {
    Background: {
      Default: {
        default: 'inherit',
      },
      Active: {
        default: 'bg.muted',
      },
      Hover: {
        default: 'bg.emphasized',
      },
    },
    FontColor: {
      default: 'fg.default',
    },
    IconColor: {
      default: 'fg.default',
    },
  },
}
